// components/Modal/Modal.tsx
import React, { useEffect } from "react";
import { CloseBtn, ModalStyled, Overlay } from "./Modal.styled";
import { CSS } from "@stitches/react";

interface ModalProps {
  onClose: () => void;
  children: React.ReactNode;
  modalStyle?: CSS;
}

export const Modal = ({ onClose, children, modalStyle = {} }: ModalProps) => {
  useEffect(() => {
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  return (
    <Overlay>
      <ModalStyled css={{ ...modalStyle }}>
        <CloseBtn onClick={onClose}>&times;</CloseBtn>
        {children}
      </ModalStyled>
    </Overlay>
  );
};
